<template>
  <div class="loader-container" data-testid="account-wallet-details-loader">
    <SkeletonLoader show-animation>
      <div class="loader loader--title" />
    </SkeletonLoader>

    <SkeletonLoader class="row-group" show-animation>
      <div v-for="row in 3" :key="row" class="loader loader--row" />
    </SkeletonLoader>

    <SkeletonLoader class="text-group" show-animation>
      <div v-for="text in 6" :key="text" class="loader loader--text" />
    </SkeletonLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'AccountWalletDetailsLoader',
  components: { SkeletonLoader }
})
export default class AccountWalletDetailsLoader extends Vue {}
</script>

<style lang="less" scoped>
.loader {
  background: @background-tertiary;
  border-radius: 10px;

  &-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &--title {
    height: 17px;
    width: 55%;
    margin-bottom: @size-spacing-x300;
  }

  &--row {
    height: 52px;
  }

  &--text {
    height: 18px;
  }
}

.row-group {
  > :first-child {
    margin-top: @size-spacing-x350;
  }

  > * {
    margin: @size-spacing-x500 0 @size-spacing-x500;
  }
}

.text-group {
  margin-top: @size-spacing-x400;

  > *:not(:first-child) {
    margin-top: @size-spacing-x300;
  }
}
</style>
